// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.survey-preview-modal .modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}

.survey-preview-modal .modal-content {
  position: relative;
  z-index: 100000;
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.survey-preview-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.survey-preview-modal .modal-header h2 {
  margin: 0 0 0.5rem 0;
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 700;
}

.preview-badge {
  background: #667eea;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
}

.survey-preview-modal .btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6b7280;
  padding: 0.5rem;
  line-height: 1;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.survey-preview-modal .btn-close:hover {
  color: #374151;
  background: #f3f4f6;
}

.survey-preview-modal .modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
}

.survey-preview-container {
  padding: 2rem;
}

.survey-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.survey-header h1 {
  margin: 0 0 0.75rem 0;
  color: #1f2937;
  font-size: 1.875rem;
  font-weight: 700;
}

.survey-header p {
  margin: 0 0 1.5rem 0;
  color: #6b7280;
  font-size: 1rem;
  line-height: 1.6;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(to right, #667eea, #764ba2);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-text {
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
}

.questions-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 2rem;
}

.preview-question {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
}

.question-label {
  display: block;
  margin-bottom: 1rem;
  color: #1f2937;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.5;
}

.required {
  color: #ef4444;
  margin-left: 0.25rem;
}

.options-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.radio-option,
.checkbox-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.radio-option:hover,
.checkbox-option:hover {
  border-color: #667eea;
  background: #f0f7ff;
}

.radio-option input,
.checkbox-option input {
  margin: 0;
  transform: scale(1.2);
}

.text-answer {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
}

.text-answer:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.rating-group {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.rating-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 50px;
}

.rating-option:hover {
  border-color: #667eea;
  background: #f0f7ff;
}

.rating-option input {
  margin: 0;
  transform: scale(1.2);
}

.rating-label {
  font-weight: 600;
  color: #374151;
}

.dropdown-answer {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.875rem;
  background: white;
  cursor: pointer;
}

.dropdown-answer:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.file-upload-preview {
  background: white;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
}

.file-upload-placeholder {
  color: #6b7280;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.file-upload-info {
  color: #9ca3af;
  font-size: 0.75rem;
  margin-top: 0.5rem;
}

.navigation-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.nav-center {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.btn {
  display: inline-flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #5a67d8;
  transform: translateY(-1px);
}

.btn-secondary {
  background: #f3f4f6;
  color: #374151;
}

.btn-secondary:hover {
  background: #e5e7eb;
}

.btn-outline {
  background: transparent;
  color: #667eea;
  border: 1px solid #667eea;
}

.btn-outline:hover {
  background: #667eea;
  color: white;
}

.btn-success {
  background: #10b981;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: #059669;
  transform: translateY(-1px);
}

/* Dark Mode Styles */
.dark .survey-preview-modal .modal-content {
  background: #1f2937;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.dark .survey-preview-modal .modal-header {
  background: #111827;
  border-bottom: 1px solid #374151;
}

.dark .survey-preview-modal .modal-header h2 {
  color: #f3f4f6;
}

.dark .survey-preview-modal .btn-close {
  color: #9ca3af;
}

.dark .survey-preview-modal .btn-close:hover {
  color: #e5e7eb;
  background: #374151;
}

.dark .survey-header {
  border-bottom: 1px solid #374151;
}

.dark .survey-header h1 {
  color: #f3f4f6;
}

.dark .survey-header p {
  color: #9ca3af;
}

.dark .progress-bar {
  background: #374151;
}

.dark .progress-text {
  color: #9ca3af;
}

.dark .questions-container {
  background: transparent;
}

.dark .preview-question {
  background: #111827;
  border: 1px solid #374151;
}

.dark .question-label {
  color: #f3f4f6;
}

.dark .radio-option,
.dark .checkbox-option {
  background: #1f2937;
  border: 1px solid #4b5563;
}

.dark .radio-option:hover,
.dark .checkbox-option:hover {
  border-color: #667eea;
  background: #374151;
}

.dark .radio-option span,
.dark .checkbox-option span {
  color: #e5e7eb;
}

.dark .text-answer {
  background: #1f2937;
  border: 1px solid #4b5563;
  color: #f3f4f6;
}

.dark .text-answer:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.dark .rating-option {
  background: #1f2937;
  border: 1px solid #4b5563;
}

.dark .rating-option:hover {
  border-color: #667eea;
  background: #374151;
}

.dark .rating-label {
  color: #e5e7eb;
}

.dark .dropdown-answer {
  background: #1f2937;
  border: 1px solid #4b5563;
  color: #f3f4f6;
}

.dark .dropdown-answer:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.dark .dropdown-answer option {
  background: #1f2937;
  color: #f3f4f6;
}

.dark .file-upload-preview {
  background: #1f2937;
  border: 2px dashed #4b5563;
}

.dark .file-upload-placeholder {
  color: #9ca3af;
}

.dark .file-upload-info {
  color: #6b7280;
}

.dark .navigation-buttons {
  border-top: 1px solid #374151;
}

.dark .btn-secondary {
  background: #374151;
  color: #e5e7eb;
}

.dark .btn-secondary:hover {
  background: #4b5563;
}

.dark .btn-outline {
  color: #667eea;
  border: 1px solid #667eea;
}

.dark .btn-outline:hover {
  background: #667eea;
  color: white;
}

/* Responsive Design */
@media (max-width: 768px) {
  .survey-preview-modal {
    padding: 0.5rem;
  }
  
  .survey-preview-container {
    padding: 1rem;
  }
  
  .survey-header h1 {
    font-size: 1.5rem;
  }
  
  .rating-group {
    justify-content: center;
  }
  
  .navigation-buttons {
    flex-direction: column;
    gap: 1rem;
  }
  
  .nav-center {
    order: -1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SurveyPreviewModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uDAAuD;EACvD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".survey-preview-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.survey-preview-modal .modal-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 99999;\n}\n\n.survey-preview-modal .modal-content {\n  position: relative;\n  z-index: 100000;\n  background: white;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 900px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.survey-preview-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f8fafc;\n}\n\n.survey-preview-modal .modal-header h2 {\n  margin: 0 0 0.5rem 0;\n  color: #1f2937;\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.preview-badge {\n  background: #667eea;\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.survey-preview-modal .btn-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 0.5rem;\n  line-height: 1;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.survey-preview-modal .btn-close:hover {\n  color: #374151;\n  background: #f3f4f6;\n}\n\n.survey-preview-modal .modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.survey-preview-container {\n  padding: 2rem;\n}\n\n.survey-header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.survey-header h1 {\n  margin: 0 0 0.75rem 0;\n  color: #1f2937;\n  font-size: 1.875rem;\n  font-weight: 700;\n}\n\n.survey-header p {\n  margin: 0 0 1.5rem 0;\n  color: #6b7280;\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(to right, #667eea, #764ba2);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  color: #6b7280;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.questions-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.preview-question {\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.question-label {\n  display: block;\n  margin-bottom: 1rem;\n  color: #1f2937;\n  font-size: 1.125rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.required {\n  color: #ef4444;\n  margin-left: 0.25rem;\n}\n\n.options-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.radio-option,\n.checkbox-option {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.radio-option:hover,\n.checkbox-option:hover {\n  border-color: #667eea;\n  background: #f0f7ff;\n}\n\n.radio-option input,\n.checkbox-option input {\n  margin: 0;\n  transform: scale(1.2);\n}\n\n.text-answer {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 100px;\n}\n\n.text-answer:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.rating-group {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.rating-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 50px;\n}\n\n.rating-option:hover {\n  border-color: #667eea;\n  background: #f0f7ff;\n}\n\n.rating-option input {\n  margin: 0;\n  transform: scale(1.2);\n}\n\n.rating-label {\n  font-weight: 600;\n  color: #374151;\n}\n\n.dropdown-answer {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  background: white;\n  cursor: pointer;\n}\n\n.dropdown-answer:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.file-upload-preview {\n  background: white;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 2rem;\n  text-align: center;\n}\n\n.file-upload-placeholder {\n  color: #6b7280;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n}\n\n.file-upload-info {\n  color: #9ca3af;\n  font-size: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.navigation-buttons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.nav-center {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n}\n\n.btn-primary {\n  background: #667eea;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #5a67d8;\n  transform: translateY(-1px);\n}\n\n.btn-secondary {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.btn-secondary:hover {\n  background: #e5e7eb;\n}\n\n.btn-outline {\n  background: transparent;\n  color: #667eea;\n  border: 1px solid #667eea;\n}\n\n.btn-outline:hover {\n  background: #667eea;\n  color: white;\n}\n\n.btn-success {\n  background: #10b981;\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background: #059669;\n  transform: translateY(-1px);\n}\n\n/* Dark Mode Styles */\n.dark .survey-preview-modal .modal-content {\n  background: #1f2937;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);\n}\n\n.dark .survey-preview-modal .modal-header {\n  background: #111827;\n  border-bottom: 1px solid #374151;\n}\n\n.dark .survey-preview-modal .modal-header h2 {\n  color: #f3f4f6;\n}\n\n.dark .survey-preview-modal .btn-close {\n  color: #9ca3af;\n}\n\n.dark .survey-preview-modal .btn-close:hover {\n  color: #e5e7eb;\n  background: #374151;\n}\n\n.dark .survey-header {\n  border-bottom: 1px solid #374151;\n}\n\n.dark .survey-header h1 {\n  color: #f3f4f6;\n}\n\n.dark .survey-header p {\n  color: #9ca3af;\n}\n\n.dark .progress-bar {\n  background: #374151;\n}\n\n.dark .progress-text {\n  color: #9ca3af;\n}\n\n.dark .questions-container {\n  background: transparent;\n}\n\n.dark .preview-question {\n  background: #111827;\n  border: 1px solid #374151;\n}\n\n.dark .question-label {\n  color: #f3f4f6;\n}\n\n.dark .radio-option,\n.dark .checkbox-option {\n  background: #1f2937;\n  border: 1px solid #4b5563;\n}\n\n.dark .radio-option:hover,\n.dark .checkbox-option:hover {\n  border-color: #667eea;\n  background: #374151;\n}\n\n.dark .radio-option span,\n.dark .checkbox-option span {\n  color: #e5e7eb;\n}\n\n.dark .text-answer {\n  background: #1f2937;\n  border: 1px solid #4b5563;\n  color: #f3f4f6;\n}\n\n.dark .text-answer:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.dark .rating-option {\n  background: #1f2937;\n  border: 1px solid #4b5563;\n}\n\n.dark .rating-option:hover {\n  border-color: #667eea;\n  background: #374151;\n}\n\n.dark .rating-label {\n  color: #e5e7eb;\n}\n\n.dark .dropdown-answer {\n  background: #1f2937;\n  border: 1px solid #4b5563;\n  color: #f3f4f6;\n}\n\n.dark .dropdown-answer:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.dark .dropdown-answer option {\n  background: #1f2937;\n  color: #f3f4f6;\n}\n\n.dark .file-upload-preview {\n  background: #1f2937;\n  border: 2px dashed #4b5563;\n}\n\n.dark .file-upload-placeholder {\n  color: #9ca3af;\n}\n\n.dark .file-upload-info {\n  color: #6b7280;\n}\n\n.dark .navigation-buttons {\n  border-top: 1px solid #374151;\n}\n\n.dark .btn-secondary {\n  background: #374151;\n  color: #e5e7eb;\n}\n\n.dark .btn-secondary:hover {\n  background: #4b5563;\n}\n\n.dark .btn-outline {\n  color: #667eea;\n  border: 1px solid #667eea;\n}\n\n.dark .btn-outline:hover {\n  background: #667eea;\n  color: white;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .survey-preview-modal {\n    padding: 0.5rem;\n  }\n  \n  .survey-preview-container {\n    padding: 1rem;\n  }\n  \n  .survey-header h1 {\n    font-size: 1.5rem;\n  }\n  \n  .rating-group {\n    justify-content: center;\n  }\n  \n  .navigation-buttons {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .nav-center {\n    order: -1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
